import { UserAndOrganizationFeatures } from "@/api/endpoints/features";
import { FeatureType } from "@/features";

import { useFeatures } from "./useFeatures";

/**
 * Accepts any combination or length of features and returns true if the user has all of them
 *
 * The feature system (shared with the backend) is documented in `customers/features.py`
 */
export const useHasFeature = (...features: FeatureType[]): boolean => {
  const { data } = useFeatures();

  if (!data?.data) return false;

  return features.every((feature) => {
    const hasFeatures = data.data as UserAndOrganizationFeatures;
    const userLevel = hasFeatures.user?.[feature];
    const orgLevel = hasFeatures.organization?.[feature];

    // Check if the user has the feature. If they do, return true
    if (userLevel === true) return true;

    // If the userLevel failed, check if the org has the feature. If they do and the user is not explicitly false, it's true.
    if (orgLevel === true && userLevel !== false) return true;

    return false;
  });
};
